import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import RolePermissionsEditor from '../rolePermissionsEditor/RolePermissionsEditor';
import { StackLayout, TextInput } from '@wemogy/reactbase';
import useAuthorizationStore from '../../../hooks/UseAuthorizationStore';
var RoleEditor = function (_a) {
    var role = _a.role;
    var config = useAuthorizationStore().config;
    var handleRoleNameChange = useCallback(function (newName) {
        role.beginEditing();
        role.setName(newName);
        role.pauseEditing();
    }, [role]);
    return (React.createElement(StackLayout, { width100: true },
        React.createElement(StackLayout, null,
            React.createElement(TextInput, { onChange: handleRoleNameChange, placeholder: config.ui.manageRoleModal.roleNamePlaceholder, variationKey: config.ui.manageRoleModal.roleNameTextInputVariation, value: role.name }),
            React.createElement(StackLayout, { marginTopBottom: true, height: { custom: 2 }, backgroundColor: "grey600" })),
        React.createElement(RolePermissionsEditor, { role: role })));
};
export default observer(RoleEditor);
//# sourceMappingURL=RoleEditor.js.map